import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

import WebpartTemplate from "@webparts/components/webparts/base/WebpartTemplate.vue";
import WebpartBase from "@webparts/components/webparts/base/WebpartBase";
import { LoadingBar } from "@appbase/components/loading";
import NoData from "@webparts/components/common/NoData.vue";
import OrgModalView from "@orgmap/views/OrgmapModalView.vue";

import * as usertypes from "@account/store/types";
import gnbApi from "@gnb/api";
import modalHelper from "@appbase/util/modal-helper";
import { openPopup } from "@appbase/util/popup-helper";
import { getLangProperty } from '@appbase/util'




const tempData: gnb.QuickMenuItem[] = [
    {
        quickMenuId: 1,
        comCode: '10',
        parentQuickMenuId: 0,
        title: "바로가기1",
        titleEn: "Shortcut1",
        titleCh: "Shortcut1_ch",
        titleJp: "Shortcut1_jp",
        linkUrl: "https://www.google.com",
        order: 1,
        isUse: true,
        isRequire: false,
        isDefault: false,
        linkType: 'Q',
        moveType: 1,
        width: 0,
        height: 0,
        filePath: '',
        fileName: '',
        savedFileName: '',
        fileSize: 0,
        hasChildren: false,
        childItems: [],
        userSet: false
    },
    {
        quickMenuId: 2,
        comCode: '10',
        parentQuickMenuId: 0,
        title: "바로가기2",
        titleEn: "Shortcut2",
        titleCh: "Shortcut2_ch",
        titleJp: "Shortcut2_jp",
        linkUrl: "https://www.naver.com",
        order: 2,
        isUse: true,
        isRequire: false,
        isDefault: false,
        linkType: 'Q',
        moveType: 1,
        width: 0,
        height: 0,
        filePath: '',
        fileName: '',
        savedFileName: '',
        fileSize: 0,
        hasChildren: false,
        childItems: [],
        userSet: false
    },
];

@Component({
    name: "shortcut-webpart",
    components: {
        LoadingBar,
        NoData,
        WebpartTemplate,
    },
    computed: {
        ...mapGetters({
            user: usertypes.USER,
        }),
    },
})
export default class ShortcutWebpart extends Mixins(WebpartBase) {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) webpart!: webpartv3.Webpart;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    user!: account.TUser;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    shortcutList: gnb.QuickMenuItem[] = [];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    handleClick(menu: gnb.QuickMenuItem) {
        if (this.preview) return;

        let url = menu.linkUrl.toString();
        if (url.includes("{{token}}")) {
            let convertedComCode = encodeURIComponent(btoa(this.user.comCode));
            let convertedAccount = encodeURIComponent(btoa(this.user.personId));
            let tokenString = `bCC=${convertedComCode}&bAC=${convertedAccount}`;

            url = url.replace("{{token}}", tokenString);
        }
        if(url.includes('/orgmap')){
            this.openOrgMap();
        }
        // 페이지 이동
        else if(menu.moveType === 0){
            window.open(url);
        }
        // 새탭
        else if(menu.moveType === 1){
            window.open(url, "_blank");
        }
        // 팝업
        else if(menu.moveType === 2){
            window.open(url, "shortcut-webpart", 'popup=1');
        }
    }

    // 조직도 Open
    openOrgMap() {
        let options = {
            personal: false,
            public: false,
            single: true,
            searchAll: false,
            searchKeyword: null,
            containers: [],
        };
        if (this.isTeams) {
            modalHelper.show({
                component: OrgModalView,
                force: true,
                value: {
                    options: options,
                },
            });
        } else {
            openPopup(
                "shortcut-webpart",
                "/orgmap",
                { event: "OrgPopup", option: options },
                {
                    width: 1200,
                    height: 700,
                }
            );
        }
    }

    load() {
        this.loading = true;

        gnbApi.gnb.getUserQuickMenuList(this.user.personCode, this.user.comCode, "U").then((res: gnb.QuickMenuItem[]) => {
            if (res) {
                this.shortcutList = res.filter(item => item.linkType === 'Q');
                this.loading = false;
            }
        }).catch((err: any) => {
            console.error(err);
            this.loading = false;
        })
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H E S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E S T Y L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    created() {
        if (this.preview) {
            this.shortcutList = tempData;
        } else {
            this.load();
        }
    }
}
